<template>
  <div>
    <img :src="course.course_image" alt="course image" class="course-image" />
    <div class="course-details">
      <h4>{{ course.name }}</h4>
      <p class="duration">
        {{ course.duration }} minutes
        <span class="ml-2">
          {{ convertDate(course.date + " " + course.time) }}
        </span>
      </p>
      <p class="price" v-if="course.payment_option != 'free'">
        {{ course.price }} Azadi Coin (AC)
      </p>
      <p class="price" v-else>FREE</p>
      <p class="duration closeIn" v-if="!isClosed">Registration closes in</p>
      <div class="time">{{ countdown }}</div>
    </div>
    <router-link v-if="!isClosed" :to="'/training-detail/' + course.id"
      ><button class="enroll-btn">Enroll Now</button></router-link
    >
  </div>
</template>
<script>
export default {
  props: ["course"],
  data() {
    return {
      isClosed: false,
      futureDate: new Date(this.course.date + " " + this.course.time),
      countdown: '',
      intervalId: null,
      oneHourBefore: null
    };
  },
  mounted() {
    this.calculateOneHourBefore();
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    calculateOneHourBefore() {
      this.oneHourBefore = new Date(this.futureDate.getTime() - 60 * 60 * 1000);
    },
    startCountdown() {
      this.updateCountdown();
      this.intervalId = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    updateCountdown() {
      const now = new Date();
      const diff = this.oneHourBefore - now;
      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.countdown = `${days} Days | ${hours} hrs | ${minutes} mins | ${seconds} secs`;
      } else {
        this.isClosed = true;
        this.countdown = "Enrollment Closed";
        clearInterval(this.intervalId);
      }
    },
    convertDate(dateStr) {
      const date = new Date(dateStr);

      const formattedDate = date
        .toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
          timeZone: "UTC",
        })
        .replace(",", " ");

      return formattedDate;
    },
  },
};
</script>
<style scoped>
.course-image {
  width: 100%;
  border-radius: 5px;
  border-bottom: 5px solid #f0c57a;
}

.course-details {
  padding: 0.5rem;
  flex: 1;
}

.course-details h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.course-details p {
  margin-top: 0.8rem;
}

.duration {
  font-size: 0.8rem;
  color: rgb(178, 178, 178);
}

.price {
  font-weight: bold;
}

.enroll-btn {
  padding: 0.5rem 1rem;
  border: none;
  width: 100%;
  background-color: #f0c57a;
  color: #000;
  cursor: pointer;
  margin-top: 1rem;
  font-size: 1rem;
}

.ml-2 {
  margin-left: 0.9rem;
}
.closeIn {
  margin-top: 1rem;
}
.enroll-btn:hover {
  background-color: #aacae7;
}
.time {
  margin-top: 0.5rem;
  font-weight: 800;
  color: #f29430;
}
</style>
